module.exports = __webpack_public_path__ + "static/media/eric-rebecca-akaka-falls@1x.1ff1be4e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/eric-rebecca-akaka-falls@1x.jpg
// module id = 476
// module chunks = 0